import { collection } from 'infra/collection'
import { BusinessProfileVersion } from './BusinessProfileVersion'
import { BusinessProfileVersionDto } from './dtos'
import { BusinessProfilesAPI } from './API'
import { Id } from 'types/definitions'

export default class BusinessProfileStore {
  businessProfiles = collection<
    BusinessProfileVersionDto,
    BusinessProfileVersion
  >({
    create: () => new BusinessProfileVersion(),
    getDataId: (data) => `${data.id}:${data.version}`,
    getModelId: (model) => `${model.id}:${model.version}`,
  })

  constructor(private api: BusinessProfilesAPI) {}

  /**
   * Gets business profile.
   */
  getBusinessProfile(id: Id, version: number) {
    return this.businessProfiles.get(`${id}:${version}`)
  }

  /**
   * Fetches business profile for a given job ID.
   */
  async fetchBusinessProfileForJob(jobId: Id) {
    return this.api.getBusinessProfileForJob(jobId).then((profile) => {
      return this.businessProfiles.set(profile)
    })
  }

  /**
   * Fetches business profile.
   */
  async fetchBusinessProfile(id: Id) {
    return this.api.getBusinessProfile(id).then((profile) => {
      return this.businessProfiles.set(profile)
    })
  }
}
